import PropTypes from 'prop-types';
import { MaintenancePage } from '@artprov/design-system';
import noAccessImage from '../assets/images/no-access.png';

/**
 * Obtiene la URL del portal según el ambiente.
 *
 * @param {string|undefined} customRedirect - URL customizada de redirección. Si se provee, tiene precedencia.
 * @returns {string} URL del portal del ambiente correspondiente.
 */
const getPortalUrl = (customRedirect) => {
    if (customRedirect) {
        return customRedirect
    }

    const entorno = import.meta.env.ENTORNO || 'prod'

    /** @type {Record<string, string>} */
    const portalUrls = {
        develop: 'https://dev-portal.artprovincia.ar/',
        test: 'https://test-portal.artprovincia.ar/',
        beta: 'https://beta-portal.artprovincia.ar/',
        prod: 'https://portal.artprovincia.ar/',
    }

    return portalUrls[entorno] || portalUrls.prod
}

export function NoRoleAccessFallback({ customRedirect }) {
    return (
        <MaintenancePage
            buttonText="Ir al portal"
            buttonIcon="arrow_back_ios"
            onClickButton={() => {
                globalThis.location.href = getPortalUrl(customRedirect)
            }}
            inscription="Lo sentimos"
            title="Acceso restringido"
            description="Tu usuario no cuenta con los permisos necesarios. Solicitá los permisos al área de sistemas o seguridad informática para poder acceder."
            withoutHeader
            status={403}
            image={noAccessImage}
        />
    );
}

NoRoleAccessFallback.propTypes = {
    customRedirect: PropTypes.string,
}
